import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
import { Checkbox } from '../ui/Checkbox';
import { Badge } from '../ui/Badge';
interface Step6Props {
  schedules: any[];
  trainees: Array<{
    id: string;
    name: string;
    phone: string;
    email: string;
  }>;
  attendance: Record<string, any[]>;
  onChange: (scheduleId: string, attendance: any[]) => void;
}
export function Step6Attendance({
  schedules,
  trainees,
  attendance,
  onChange
}: Step6Props) {
  const [selectedSchedule, setSelectedSchedule] = useState('');
  const scheduleOptions = schedules.map((s, index) => ({
    value: s.id,
    label: `Day ${s.day} - ${s.startTime} to ${s.endTime} (${s.subject})`
  }));
  const currentAttendance = selectedSchedule ? attendance[selectedSchedule] || [] : [];
  const toggleAttendance = (traineeId: string) => {
    if (!selectedSchedule) return;
    const existing = currentAttendance.find(a => a.traineeId === traineeId);
    let newAttendance;
    if (existing) {
      newAttendance = currentAttendance.map(a => a.traineeId === traineeId ? {
        ...a,
        status: a.status === 'present' ? 'absent' : 'present'
      } : a);
    } else {
      newAttendance = [...currentAttendance, {
        traineeId,
        scheduleId: selectedSchedule,
        status: 'present'
      }];
    }
    onChange(selectedSchedule, newAttendance);
  };
  const markAllPresent = () => {
    if (!selectedSchedule) return;
    const newAttendance = trainees.map(t => ({
      traineeId: t.id,
      scheduleId: selectedSchedule,
      status: 'present'
    }));
    onChange(selectedSchedule, newAttendance);
  };
  const getAttendanceStatus = (traineeId: string) => {
    const record = currentAttendance.find(a => a.traineeId === traineeId);
    return record?.status === 'present';
  };
  return <Card title="Attendance Management" data-id="element-172">
      <div className="space-y-6" data-id="element-173">
        <div className="flex gap-4 items-end" data-id="element-174">
          <div className="flex-1" data-id="element-175">
            <Select label="Select Session" value={selectedSchedule} onChange={e => setSelectedSchedule(e.target.value)} options={scheduleOptions} data-id="element-176" />
          </div>
          {selectedSchedule && <Button onClick={markAllPresent} data-id="element-177">Mark All Present</Button>}
        </div>

        {!selectedSchedule ? <div className="text-center py-12 text-gray-500" data-id="element-178">
            Select a session to mark attendance
          </div> : <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-179">
            <table className="w-full" data-id="element-180">
              <thead className="bg-gray-50 border-b border-gray-200" data-id="element-181">
                <tr data-id="element-182">
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-183">
                    SL
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-184">
                    Name
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-185">
                    Phone
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-186">
                    Email
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" data-id="element-187">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-188">
                {trainees.map((trainee, index) => {
              const isPresent = getAttendanceStatus(trainee.id);
              return <tr key={trainee.id} className="hover:bg-gray-50" data-id="element-189">
                      <td className="px-4 py-3 text-sm text-gray-900" data-id="element-190">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900" data-id="element-191">
                        {trainee.name}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900" data-id="element-192">
                        {trainee.phone}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900" data-id="element-193">
                        {trainee.email}
                      </td>
                      <td className="px-4 py-3" data-id="element-194">
                        <Checkbox label={isPresent ? 'Present' : 'Absent'} checked={isPresent} onChange={() => toggleAttendance(trainee.id)} data-id="element-195" />
                      </td>
                    </tr>;
            })}
              </tbody>
            </table>
          </div>}
      </div>
    </Card>;
}